import { Breadcrumbs, Anchor, rem } from '@mantine/core';
import { Link } from 'react-router-dom';

interface Breadcrumb {
    title: string;
    href?: string;
}

interface DesktopBreadcrumbsProps {
    breadcrumbs?: Breadcrumb[];
}

export const DesktopBreadcrumbs = ({ breadcrumbs }: DesktopBreadcrumbsProps) => {
    if (!breadcrumbs?.length) return null;

    return (
        <Breadcrumbs
            separator="/"
            mb={rem(8)}
            styles={{
                root: {
                    flexWrap: 'wrap'
                },
                breadcrumb: {
                    fontSize: rem(13),
                    fontWeight: 500
                }
            }}
        >
            {breadcrumbs.map((crumb, index) => (
                <Anchor
                    key={index}
                    component={crumb.href ? Link as any : 'span'}
                    to={crumb.href}
                    c={index === breadcrumbs.length - 1 ? 'dimmed' : 'blue'}
                    style={{
                        textDecoration: 'none',
                        opacity: index === breadcrumbs.length - 1 ? 0.7 : 1,
                        fontSize: rem(13)
                    }}
                >
                    {crumb.title}
                </Anchor>
            ))}
        </Breadcrumbs>
    );
};
